import { QueryClient } from "@tanstack/react-query";

// gcTime a week so persisted offline reads survive restarts (D-8);
// mutations run even offline so the outbox (not a paused mutation that a
// reload would lose) owns the offline story. One client, module-level, so
// wipeDevice() can empty it without a React tree in hand.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, gcTime: 7 * 24 * 3600_000 },
    mutations: { networkMode: "always" },
  },
});
